import {SkeletonBlock} from '@aboutyou/ui-components';
import {range} from '@aboutyou/utils';
import React, {FC} from 'react';
import styled from 'styled-components';
import {useSessionGender} from '../../../shared-deprecated/sessionGender';
import {TileCSS, WrapperCSS} from './CategoryTilesView';

export const CategoryTilesLoading: FC<{className?: string}> = ({className}) => {
  const {gender} = useSessionGender();

  const numberOfTiles = gender === 'kids' ? 6 : 9;

  return (
    <Wrapper className={className}>
      {range(0, numberOfTiles).map((_, index) => (
        <InnerWrapper key={index}>
          <SkeletonBlock
            style={{
              borderRadius: '8px',
              aspectRatio: '1 / 1',
              height: '100%',
              marginBottom: '0.5rem',
            }}
          />
          <SkeletonBlock
            $width="80%"
            $height="16px"
            style={{
              marginBottom: 0,
            }}
          />
        </InnerWrapper>
      ))}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  ${WrapperCSS}
`;

const InnerWrapper = styled.div`
  ${TileCSS}

  align-items: center;
  display: flex;
  flex-direction: column;
`;
